import { apiClient } from "../utils";

export const getVoucherLists = async (mongoShopId: string) => {
  const { data } = await apiClient.get<any>(`shop/${mongoShopId}/settings/common/voucherList`);

  return data;
};
